import gql from 'graphql-tag';

const GET_SCHEDULE_WINDOW = gql`
    query getScheludeWindow (
        $newDate: String,
        $idOrder: String,
        $slaType: String,
        $store: String) {
        getScheduleWindow (
            newDate: $newDate,
            idOrder: $idOrder,
            slaType: $slaType,
            store: $store
        ) {
            id,
            window,
            fullWindow,
            courierName,
            courierId
        }
    }
`;

export default GET_SCHEDULE_WINDOW;
